import React, { useState } from "react"
import { neonMessages } from "../../../../dummy/messages";
import { Profile } from "../../../shared/profile";
import { Header } from "./header";
import { Conversations } from "./conversations";
import neonStore from '../../../../stores/useNeon'
import clx from "classnames";

export const Content = () => {
    // Alternative: const [messages, setMessages] = useState(neonMessages );
    const {messages, detail, setMessages} = neonStore(state=>state)

    const [profile, setProfile] = useState(false);
    const [menu, setMenu] = useState(false);
    const [posted, setPosted] = useState('')
  
    const handle = (emoji,id) => {
      let newMessages = [...messages]
      const index =  newMessages.findIndex(f=>f.id==id)
      
      newMessages.map(msg=>{
        if(!msg['reactions']){
          msg['reactions'] = []
        }
      })
  
      let selected = newMessages[index]; 
      let reactions = selected.reactions
  
      let isHave = reactions.find(f=>f.emoji == emoji)
      let isHaveIndex = reactions.findIndex(f=>f.emoji == emoji)
      if(!isHave){      
        let newReactions = [ ...reactions, {emoji, count:1, voted:true} ]
        selected = { ...selected, reactions: newReactions}
        newMessages[index] = selected
        setMessages(newMessages)
        return;
      }else{
  
        if(!isHave.voted){
          isHave.voted = true;
          isHave.count++
          
          reactions[isHaveIndex] = isHave;
  
          let newReactions = [ ...reactions ]
          selected = { ...selected, reactions: newReactions}
          newMessages[index] = selected
          setMessages(newMessages)
  
        }else{
  
         
          isHave.voted = false;
          --isHave.count
          
          reactions[isHaveIndex] = isHave;
          let newReactions = [ ...reactions ]
  
          if(isHave.count<=1){
            newReactions = reactions.filter(r=>r.emoji!=isHave.emoji)
          }
  
          selected = { ...selected, reactions: newReactions}
          newMessages[index] = selected
          setMessages(newMessages)
  
        }
  
      }
  
  
  
  
      
    }
  
    const isToday = (date) => {
      const someDate = new Date(date)
      const today = new Date()
      return someDate.getDate() == today.getDate() &&
        someDate.getMonth() == today.getMonth() &&
        someDate.getFullYear() == today.getFullYear()
    }

    return (
        <React.Fragment>
            <div
                className={clx(detail?'col-span-6':'col-span-8', `content col-span-6 h-screen flex flex-col scrollbar justify-between 
                dark:bg-[#16191c] bg-[#fcfcfc]`)}
            >
                <div
                    className="conversation h-full overflow-y-auto overflow-x-hidden relative"
                >
                  
                <Header
                profile={profile}
                setProfile={setProfile}
                menu={menu}
                setMenu={setMenu}
                />

                <Profile profile={profile} />

                <Conversations 
                    profile={profile}
                    messages={messages}
                    setProfile={setProfile}
                    handle={handle}
                    isToday={isToday}
                    posted={posted}
                    setPosted={setPosted}
                />

            </div>
            </div>
        </React.Fragment>
    )
}
